document.addEventListener("alpine:init", () => {
  Alpine.data("ThemeSection_MarketsDrawer", () => {
    return {
      init() {
        initTeleport(this.$root);
        Alpine.store("modals").register("markets-drawer", "rightDrawer");
      },
    };
  });

  Alpine.data("countrySelector", () => {
    return {
      query: "",

      filterCountry(countryName, currency) {
        if (this.query === "") return true;
        const searchTerm = this.query.toLowerCase();
        return (
          countryName.toLowerCase().includes(searchTerm) ||
          currency.toLowerCase().includes(searchTerm)
        );
      },

      noCountriesVisible() {
        if (this.query === "") return false;
        const countryOptions = this.$el.querySelectorAll(".country-option");
        let visibleCount = 0;
        countryOptions.forEach((option) => {
          const isVisible =
            option.style.display !== "none" &&
            !option.hasAttribute("x-cloak") &&
            option.offsetHeight > 0;
          if (isVisible) {
            visibleCount++;
          }
        });
        return visibleCount === 0;
      },

      selectCountry(countryCode) {
        const hiddenInput = this.$refs.hiddenInput;
        if (hiddenInput) {
          hiddenInput.value = countryCode;
          const form = hiddenInput.closest("form");
          if (form) {
            form.submit();
          }
        }
      },
    };
  });
});
